module.exports = __webpack_public_path__ + "static/media/hlavni-oltar.00ccbde3.jpg";